import { connect } from 'react-redux'
import * as selector from '../../../customer/state/detail/selector'
import Create3DScanAppointment from '../task-detail/Create3DScanAppointment'

const mapStateToProps = (state) => {
    return {
        customer: selector.selectCustomer(state),
    }
}

export default connect(mapStateToProps)(Create3DScanAppointment)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/Create3DScanAppointmentContainer.js